module.exports = __webpack_public_path__ + "static/media/noul-light.7a652138.png";